export default {
  // table
  category: {
    id: 'display_pricing_rules_category',
    defaultMessage: 'Category',
  },
  multiplier: {
    id: 'display_pricing_rules_multiplier',
    defaultMessage: 'Multiplier',
  },
  fixedAmount: {
    id: 'display_pricing_rules_offset',
    defaultMessage: 'Fixed amount',
  },
  rule: {
    id: 'display_pricing_rules_rule',
    defaultMessage: 'Rule',
  },
  allCategories: {
    id: 'display_pricing_rules_all_categories',
    defaultMessage: 'All categories',
  },
  otherCategories: {
    id: 'display_pricing_rules_other_categories',
    defaultMessage: 'Other categories',
  },
  rulePrice: {
    id: 'display_pricing_rules_price',
    defaultMessage: '{country} price × {multiplier} {sign} {offset}',
  },
  // actions
  actions: {
    id: 'display_pricing_rules_actions',
    defaultMessage: 'Open actions menu',
  },
  edit: {
    id: 'display_pricing_rules_edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'display_pricing_rules_delete',
    defaultMessage: 'Delete',
  },
  deleteError: {
    id: 'pricing_tool_delete_rule_error',
    defaultMessage: 'The rule could not be deleted. Please try again',
  },
  // price update
  updatePrices: {
    id: 'pricing_tool_update_prices',
    defaultMessage: 'Update prices now',
  },
  updateInProgress: {
    id: 'pricing_tool_update_in_progress',
    defaultMessage: 'Update in progress (≈1h)',
  },
  applyRuleError: {
    id: 'pricing_tool_apply_rule_error',
    defaultMessage: 'The rule could not be applied. Please try again.',
  },
  // toggle
  dailyUpdate: {
    id: 'pricing_tool_daily_update_new',
    defaultMessage: 'Update prices every 24 hours on listings without BuyBox',
  },
  dailyUpdateDescription: {
    id: 'pricing_tool_daily_update_description',
    defaultMessage:
      "This automatic update won't impact your listings with the BuyBox.",
  },
  // main CTA
  addAnotherRule: {
    id: 'display_pricing_rules_add_another_rule',
    defaultMessage: 'Add another rule',
  },
  toastTitle: {
    id: 'reference_market_modal_toast_title',
    defaultMessage: 'Oops!',
  },
  withoutBackBoxesInfo: {
    id: 'pricing_tool-only_without_backboxes_info',
    defaultMessage: 'This will effect all listings, with and without BackBox',
  },
}
